import React from 'react';
import { connect } from 'react-redux';
import { FormControl, TextField } from '@mui/material';
import VMasker from 'vanilla-masker';
import * as types from 'constants/actionTypes';
import SecureComponent from '../SecureComponent';

class NumberInput extends SecureComponent {
    constructor(props) {
        super(props);
        if (props.value) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.value, error: "" };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: "", error: "" };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value)//if store's value relative to this component change, update the state value
            this.setState({ value: newProps.value });
        else if (!newProps.value)//in case the store does not have any value for this component, just clear it
            this.setState({ value: "" });

        if (newProps.error && newProps.error !== this.state.error)
            this.setState({ error: newProps.error });
    }

    onChange = (event) => {
        const value = event.target.value;
        const maskedValue = VMasker.toNumber(value);

        this.setState({ value: maskedValue });
    }

    onBlur = (event) => {
        this.updateStore(event.target.value);
    }

    updateStore(value) {
        const error = this.validate(value);
        this.setState({ value, error });
        this.props.dispatch({ type: types.FORM_INPUT, value: value.replace(new RegExp(',', 'g'), ''), name: this.props.name });
    }

    validate(value) {
        const p = this.props;
        let error = null;
        if (!value && p.required)
            error = p.errorMsg ? p.errorMsg : p.name + ' is required';
        if (value && p.pattern) {
            let patt = new RegExp(p.pattern);
            if (!patt.test(value))
                error = p.patternErrorMsg ? p.patternErrorMsg : p.name + ' is invalid';
        }
        return error;
    }

    render() {
        const p = this.props;
        const e = this.state && this.state.error;
        const value = this.state && this.state.value;
        const s = this.state;
        const showError = Boolean(e && (value === '' || (!isNaN(value) && parseInt(value) === 0)));
        if (!s.authorized) return null;
        return (
            <div className="form-group">
                <FormControl className={p.className} fullWidth>
                    <TextField
                        name={p.name}
                        disabled={p.disabled}
                        variant="standard"
                        placeholder={p.hintText}
                        error={showError}
                        helperText={showError ? p.error : ''}
                        value={VMasker.toNumber(value)}
                        label={p.hintText}
                        inputProps={{
                            maxLength: p.maxLength,
                        }}
                        InputProps={{
                            style: p.inputStyle,
                        }}
                        InputLabelProps={{
                            style: p.floatingLabelStyle,
                            shrink: true
                        }}
                        fullWidth={p.fullWidth || false}
                        className={p.className}
                        onChange={this.onChange}
                        onBlur={this.onBlur}
                        ref={this.textFieldRef}
                        id={p.name}
                    />
                </FormControl>

            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name],
        userAutorizationLevel: state.common && state.common.user && state.common.user.authorizationLevel
    };
};

export default connect(mapStateToProps)(NumberInput);